export enum TagActionTypes {
    GET_TAGS_REQUEST = "GET_TAGS_REQUEST",
    GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS",
    GET_TAGS_ERROR = "GET_TAGS_ERROR"
}